module.exports = __webpack_public_path__ + "img/NS仙人白黒反転.4445c0da.png";